import { createFileRoute } from "@tanstack/react-router";

import { ConsoleAccount } from "../features/console/account";

/** `tab` is optional, so every Link to this route may omit search entirely. */
export const Route = createFileRoute("/console/account")({
  validateSearch: (search: Record<string, unknown>): { tab?: string } => {
    const tab = search["tab"];
    return typeof tab === "string" && tab !== "" ? { tab } : {};
  },
  component: ConsoleAccount,
});
